import { render } from "./Index.vue?vue&type=template&id=260e9baa&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=260e9baa&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=260e9baa&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260e9baa"]])

export default __exports__